import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { ApiResult } from '@synergy/api';
import { Dispatch } from 'redux';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../../api';
import { AppState } from '../../../../../../store/models/app-state';
import { Demand } from '../../../../models/demand';
import { PositionsFormValues } from '../../models/positions-form-values';
import { StepData } from '../../../../../../common/components/new-stepper/step-data';

export const DEMAND_DETAIL_POSITIONS_SUBMIT = 'DEMAND_DETAIL_POSITIONS_SUBMIT';
export const DEMAND_DETAIL_POSITIONS_RECEIVE = 'DEMAND_DETAIL_POSITIONS_RECEIVE';
export const DEMAND_DETAIL_POSITIONS_SAVE = 'DEMAND_DETAIL_POSITIONS_SAVE';

export const submitPositions = (data: StepData<PositionsFormValues>) => ({
    type: DEMAND_DETAIL_POSITIONS_SUBMIT,
    data,
});

export const fetchDemandPositions = () => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const demandId = getState().demandDetail.overview.stepData.values.id;

        if (demandId === undefined) {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
            return;
        }

        const response = await api.demands.get(demandId);
        if (response.success) {
            dispatch({ type: DEMAND_DETAIL_POSITIONS_RECEIVE, demand: response.result });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const savePositions = () => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        let response: ApiResult<Demand>;

        const positionsDemand = getState().demandDetail.positions.stepData.values as Partial<Demand>;
        const overviewDemands = getState().demandDetail.overview.stepData.values as Partial<Demand>;

        positionsDemand.demandItems?.map(item => {
            if (item?.id && item.id <= 0) {
                delete item.id;
            }
            return item;
        });

        // The positions carry a copy of the start date, taken when the demand
        // was loaded. Spread over the overview it wrote that stale value back
        // and undid a start date changed in the same save (#2253). The start
        // date belongs to the overview.
        const { startDate: _staleStartDate, ...positionsOnly } = positionsDemand;

        const demand = {
            ...overviewDemands, // We also need the other fields from the overview, otherwise save won't work
            ...positionsOnly,
        };
        if (demand.id) {
            response = await api.demands.patch(demand.id, demand);
        } else {
            response = await api.demands.post(demand as Demand);
        }

        if (response.success) {
            dispatch({ type: DEMAND_DETAIL_POSITIONS_RECEIVE, demand: response.result });
        } else {
            return false;
        }

        return true;
    };
};
